import { render } from "./base-select.vue?vue&type=template&id=1f0caaec"
import script from "./base-select.vue?vue&type=script&lang=js"
export * from "./base-select.vue?vue&type=script&lang=js"
script.render = render

export default script